// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0.0.13/static/js/" + chunkId + "." + "ff5f73ed" + ".chunk.js";
};